





































import { Component, Prop, Vue } from "vue-property-decorator";

import ButtonHistory from "@/components/buttons/button-history.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: { ButtonHistory, ButtonCart, InputSearch, ButtonBack },
})
export default class ExcursionCatsHeader extends Vue {
  @Prop({ type: Boolean, default: false }) categoryDeleted!: boolean;
  @Prop({ type: Number, default: 0 }) length!: number;

  get rules(): boolean {
    const rule = this.categoryDeleted
      ? this.$getRight("forceDeleteExcursionsCategoryById")
      : this.$getRight("moveExcursionsCategoryToRecycler");
    return rule && this.length ? true : false;
  }
}
